import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./double-chevron-right.svg?react";

export const DoubleChevronRightIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
